import { render, staticRenderFns } from "./MasterPageContent.vue?vue&type=template&id=54a5b404&scoped=true"
import script from "./MasterPageContent.vue?vue&type=script&lang=js"
export * from "./MasterPageContent.vue?vue&type=script&lang=js"
import style0 from "./MasterPageContent.vue?vue&type=style&index=0&id=54a5b404&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a5b404",
  null
  
)

export default component.exports